import { render, staticRenderFns } from "./DomainMoveNotice.vue?vue&type=template&id=707c7c07&scoped=true"
import script from "./DomainMoveNotice.vue?vue&type=script&lang=js"
export * from "./DomainMoveNotice.vue?vue&type=script&lang=js"
import style0 from "./DomainMoveNotice.vue?vue&type=style&index=0&id=707c7c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c7c07",
  null
  
)

export default component.exports